import { isTestEnv } from "@/lib/env";

/**
 * Boot-grace tuning. The splash auto-retries a failing boot-critical fetch up
 * to BOOT_MAX_GRACE_RETRIES times, BOOT_GRACE_INTERVAL_MS apart, before showing
 * the full-screen error page. Layered ABOVE baseQuery's transient-infra retry
 * (.claude/rules/web/performance-patterns.md §11) — total boot patience is
 * roughly baseQuery (~2-6s) + this grace (~10s) in production.
 *
 * The retry COUNT and the full retry→recover / retry→error path are identical in
 * test env (the path is still exercised end-to-end — see boot-retry.spec.ts), but
 * the INTERVAL is compressed so E2E doesn't burn ~9s of real time per boot-error
 * test. Mirrors the isTestEnv timing guards already used for polling and the
 * baseQuery retry (§11, itself disabled in test env — so this grace timer is the
 * only boot-retry delay E2E would otherwise wait on).
 */
export const BOOT_MAX_GRACE_RETRIES = 3;
export const BOOT_GRACE_INTERVAL_MS = isTestEnv ? 200 : 3000;
